// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-gradient[data-v-1d784488]{background-image:linear-gradient(90deg,transparent,#fff 70%)}.flip-arrow[data-v-1d784488]{transition:transform .3s ease}.flip-arrow.flip[data-v-1d784488]{transform:scaleX(-1)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
